// frontend/src/features/sales-rep/services/salesRepAPI.ts
import api from '../../../services/apiConfig';

export interface SalesRepData {
    vendedor: number;
    nomeVendedor: string;
    totalVenda: number;
    totalPares: number;
    totalMargem: number;
    totalClientes: number;
    numeroPedidos: number;
}

export interface ReactivationData {
    vendedor: number;
    nomeVendedor: string;
    totalReativacoes: number;
    faturamentoReativados: number;
}

export interface GoalContributionData {
    vendedor: number;
    nomeVendedor: string;
    totalVenda: number;
    meta: number;
    percentualMeta: number;
    diferenca: number;
}

export interface TimelineData {
    data: Date | string;
    vendedor: number;
    nomeVendedor: string;
    totalVenda: number;
}

export interface SalesRepKPIs {
    totalVendedores: number;
    faturamentoTotal: number;
    ticketMedio: number;
    totalReativacoes: number;
}

export interface RepActivityData {
    comVenda: number;
    semVenda: number;
    totalCadastrados: number;
    repsComVenda: { id: number; nome: string; totalVenda: number; totalPares: number }[];
    repsSemVenda: { id: number; nome: string }[];
}

export interface SalesRepAPIResponse {
    topSalesReps: SalesRepData[];
    topRepresentatives: SalesRepData[];
    reactivationLeaders: ReactivationData[];
    goalContribution: GoalContributionData[];
    salesRepTimeline: TimelineData[];
    repActivity: RepActivityData;
    kpis: SalesRepKPIs;
}

/**
 * Busca os dados de performance dos vendedores
 */
export const fetchSalesRepPerformance = (
    dataI: string,
    dataF: string,
    preset?: string
) => {
    return api.get<SalesRepAPIResponse>('/sales-rep/performance', {
        params: { dataI, dataF, preset }
    });
};